import { AuthorCard } from 'components/Author/AuthorCard';
import { Box } from 'components/Box';
import { CmsApiPagePost } from 'modules/cms/api/types/CmsApiPage';
import {
  CmsBodyContainer,
  CmsBodyContainerWidth,
} from 'modules/cms/components/Body/CmsBodyContainer';
import { CmsTagList } from 'modules/cms/components/TagList';
import { useCmsApiPageHomePageMeta } from 'modules/cms/hooks';

type Props = {
  content: CmsApiPagePost;
};

export function CmsBodyMainContentPostBelowBlocks({ content }: Props) {
  const { homePageUrl } = useCmsApiPageHomePageMeta({
    cmsApiPage: content,
  });

  return (
    <>
      {content.tags && content.tags.length > 0 && (
        <Box mb={32}>
          <CmsBodyContainer $width={CmsBodyContainerWidth.NARROW_LAYOUT}>
            <CmsTagList
              homePageUrl={content.subsite.homePage?.url}
              tags={content.tags}
            />
          </CmsBodyContainer>
        </Box>
      )}

      {content.author && (
        <CmsBodyContainer $width={CmsBodyContainerWidth.NARROW_LAYOUT}>
          <AuthorCard
            author={content.author}
            homePageUrl={homePageUrl}
            postedDate={content.postedDate}
            showDate={content.showDate}
          />
        </CmsBodyContainer>
      )}
    </>
  );
}
